// Caixa de seleção tri-estado, desenhada em <span>.
//
// Por que não é um <input type="checkbox">: o painel Cobrança seleciona por
// GRUPO, então existe um terceiro estado — "alguns dos boletos deste cliente".
// O input nativo só expressa isso via `indeterminate`, que é propriedade de DOM
// e não atributo (dá para setar, mas exige ref em toda linha). E a caixa mora
// dentro de um <td> que já trata o clique, então um controle focável aqui
// duplicaria o alvo.
//
// Antes disto o lugar usava ícones (FiSquare/FiCheckSquare) — desenho, não
// superfície: não afundam e não pertencem à gramática do tema.
export function NeuCheck({ state, className = '' }: {
  state: 'on' | 'off' | 'some'
  className?: string
}) {
  const mod = state === 'on' ? ' neu-box-on' : state === 'some' ? ' neu-box-some' : ''
  return (
    <span
      role="checkbox"
      aria-checked={state === 'on' ? 'true' : state === 'some' ? 'mixed' : 'false'}
      className={`neu-box${mod} ${className}`}
    />
  )
}
